<template>
  <v-app id="app">
    <v-dialog
      v-model="openExit"
      width="420"
      persistent
      transition="dialog-top-transition"
    >
      <v-card class="logout-dialog">
        <v-card-text class="pt-8 pb-4 px-6">
          <div class="logout-dialog__icon">
            <v-icon color="primary">mdi-logout</v-icon>
          </div>
          <h2 class="logout-dialog__title">Deseja realmente sair?</h2>
          <p class="logout-dialog__text">
            Sua sessão atual será encerrada e o retorno ao painel exigirá novo login.
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-btn elevation="0" outlined color="grey darken-1" @click="openExit = false">
            Cancelar
          </v-btn>
          <v-spacer />
          <v-btn elevation="0" color="primary" dark @click="handleLogout">
            Sair do backoffice
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      v-if="!isLoginRoute"
      v-model="drawer"
      app
      dark
      width="264"
      class="app-drawer no-print"
      :temporary="isMobile"
      :permanent="!isMobile"
    >
      <div class="app-drawer__brand">
        <div class="app-drawer__logo">
          <v-img
            width="52"
            height="44"
            contain
            :src="logo"
            alt="LOGO BRP"
          />
        </div>
        <div class="app-drawer__brand-copy">
          <strong class="app-drawer__title">Backoffice BRP</strong>
          <p class="app-drawer__subtitle">Operação, monitoramento e gestão</p>
        </div>
      </div>

      <v-divider class="app-drawer__divider" />

      <div v-show="!miniDrawer" class="app-drawer__section-label">Acesso rápido</div>
      <v-list dense nav class="app-drawer__nav">
        <v-list-item
          v-for="item in mainItems"
          :key="item.title"
          :to="item.to"
          link
          class="app-drawer__item"
          active-class="app-drawer__item--active"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div v-show="!miniDrawer" class="app-drawer__section-label">Módulos</div>
      <v-list dense nav class="app-drawer__nav">
        <v-list-group
          v-model="submenuOperations"
          no-action
          class="app-drawer__group"
          append-icon="mdi-chevron-down"
        >
          <template #activator>
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-briefcase-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Operação</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in operationsItems"
            :key="item.title"
            :to="item.to"
            link
            class="app-drawer__item app-drawer__item--nested"
            active-class="app-drawer__item--active"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-model="submenuNetwork"
          no-action
          class="app-drawer__group"
          append-icon="mdi-chevron-down"
        >
          <template #activator>
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Rede</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in networkItems"
            :key="item.title"
            :to="item.to"
            link
            class="app-drawer__item app-drawer__item--nested"
            active-class="app-drawer__item--active"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          to="/customers"
          link
          class="app-drawer__item"
          active-class="app-drawer__item--active"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Consumidores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          to="/partners"
          link
          class="app-drawer__item"
          active-class="app-drawer__item--active"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-store-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Parceiros</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          to="/phases"
          link
          class="app-drawer__item"
          active-class="app-drawer__item--active"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-cash-refund</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Cashback</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-model="submenuContent"
          no-action
          class="app-drawer__group"
          append-icon="mdi-chevron-down"
        >
          <template #activator>
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-view-grid-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Conteúdo</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in contentItems"
            :key="item.title"
            :to="item.to"
            link
            class="app-drawer__item app-drawer__item--nested"
            active-class="app-drawer__item--active"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="!isLoginRoute"
      app
      flat
      color="white"
      height="86"
      class="app-toolbar no-print"
    >
      <v-app-bar-nav-icon v-if="isMobile" color="accent" @click="handleDrawerToggle" />
      <div class="app-toolbar__content">
        <div class="app-toolbar__header">
          <div>
            <v-toolbar-title class="app-toolbar__title">
              {{ currentPage.title }}
            </v-toolbar-title>
            <p class="app-toolbar__subtitle">{{ currentPage.subtitle }}</p>
          </div>
        </div>
      </div>
      <v-spacer />
      <div class="app-toolbar__actions">
        <v-chip outlined color="primary" class="mr-2">
          Painel administrativo
        </v-chip>
        <v-btn icon color="accent" @click="openExit = true">
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :right="true"
        :top="true"
        :timeout="snackbar.timer"
      >
        {{ snackbar.message }}
        <template #action="{ attrs }">
          <v-icon color="white" v-bind="attrs" @click="snackbar.active = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <router-view class="app-page" />
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

const routeDescriptions = {
  home: {
    title: "Dashboard",
    subtitle: "Acompanhe os principais indicadores do ecossistema com leitura rápida.",
  },
  withdrawal: {
    title: "Solicitações de saque",
    subtitle: "Gerencie aprovações e acompanhe o fluxo operacional com clareza.",
  },
  products: {
    title: "Produtos",
    subtitle: "Visualize o portfólio com foco em organização, leitura e manutenção.",
  },
  productsSignatureView: {
    title: "Assinaturas do produto",
    subtitle: "Consulte vínculos e detalhes relacionados ao produto selecionado.",
  },
  franchisees: {
    title: "Franqueados",
    subtitle: "Acompanhe a estrutura comercial e os responsáveis por operação.",
  },
  franchiseeForm: {
    title: "Novo franqueado",
    subtitle: "Preencha os dados mantendo o fluxo atual de cadastro.",
  },
  franchiseeDetail: {
    title: "Detalhes do franqueado",
    subtitle: "Revise informações do registro sem alterar a regra de negócio.",
  },
  franchises: {
    title: "Franquias",
    subtitle: "Gerencie unidades com uma navegação mais clara e escaneável.",
  },
  franchiseForm: {
    title: "Nova franquia",
    subtitle: "Cadastre a unidade mantendo o comportamento atual da aplicação.",
  },
  franchiseDetail: {
    title: "Detalhes da franquia",
    subtitle: "Consulte e edite informações da unidade com mais contexto visual.",
  },
  trasactions: {
    title: "Transações",
    subtitle: "Monitore movimentações com foco em legibilidade e produtividade.",
  },
  categoriesView: {
    title: "Categorias",
    subtitle: "Organize categorias com padrão visual mais consistente.",
  },
  tutorials: {
    title: "Tutoriais",
    subtitle: "Mantenha conteúdos administrativos organizados e acessíveis.",
  },
  customersView: {
    title: "Consumidores",
    subtitle: "Filtre por status, analise cadastros e aprove ou reprove em um só lugar.",
  },
  customerDetailView: {
    title: "Consumidor",
    subtitle: "Consulte dados, documentos e ações de aprovação quando necessário.",
  },
  phases: {
    title: "Cashback",
    subtitle: "Acompanhe fases e distribuições com melhor hierarquia de informação.",
  },
  phaseDistributionView: {
    title: "Distribuição do cashback",
    subtitle: "Veja os detalhes da fase atual em uma estrutura mais clara.",
  },
  phasesLiveView: {
    title: "Cashback ao vivo",
    subtitle: "Monitore a fase em tempo real com foco em visualização.",
  },
  phasesUsersView: {
    title: "Usuários da fase",
    subtitle: "Consulte participantes e status de forma objetiva.",
  },
  partnersView: {
    title: "Parceiros",
    subtitle: "Filtre por status e gerencie todos os cadastros em um só lugar.",
  },
  partnerDetailView: {
    title: "Parceiro",
    subtitle: "Consulte dados, premium e ações de aprovação quando necessário.",
  },
  partnerDetailQRCODE: {
    title: "QR Code do parceiro",
    subtitle: "Acesse os materiais de ativação do parceiro com visual mais direto.",
  },
  associatesView: {
    title: "Associados",
    subtitle: "Gerencie o plano de carreira e a operação de associados com mais clareza.",
  },
};

export default {
  name: "App",
  data: () => ({
    drawer: true,
    openExit: false,
    submenuOperations: false,
    submenuNetwork: false,
    submenuContent: false,
    mainItems: [
      { title: "Dashboard", to: "/", icon: "mdi-view-dashboard-outline" },
    ],
    operationsItems: [
      { title: "Solicitação de saque", to: "/withdrawal", icon: "mdi-cash-fast" },
      { title: "Transações", to: "/transactions", icon: "mdi-swap-horizontal-bold" },
      { title: "Produtos", to: "/products", icon: "mdi-package-variant-closed" },
    ],
    networkItems: [
      { title: "Franqueados", to: "/franchisees", icon: "mdi-account-tie-outline" },
      { title: "Franquias", to: "/franchises", icon: "mdi-domain" },
      { title: "Associados", to: "/associates", icon: "mdi-account-star-outline" },
    ],
    contentItems: [
      { title: "Categorias", to: "/categories", icon: "mdi-shape-outline" },
      { title: "Tutoriais", to: "/tutorials", icon: "mdi-play-circle-outline" },
    ],
    logo: require("./assets/logo.png"),
  }),
  computed: {
    ...mapState(["snackbar"]),
    isLoginRoute() {
      return this.$route.name === "login";
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    currentPage() {
      return (
        routeDescriptions[this.$route.name] ||
        this.findNavigationItem(this.$route.path) || {
          title: "Backoffice",
          subtitle: "Gerencie as operações do ecossistema com uma navegação mais clara.",
        }
      );
    },
  },
  watch: {
    "$route.name": {
      immediate: true,
      handler() {
        this.syncMenuGroups();
      },
    },
  },
  methods: {
    findNavigationItem(currentPath) {
      const items = [
        ...this.mainItems,
        ...this.operationsItems,
        ...this.networkItems,
        { title: "Consumidores", to: "/customers" },
        { title: "Parceiros", to: "/partners" },
        { title: "Cashback", to: "/phases" },
        ...this.contentItems,
      ];
      const item = items.find(({ to }) =>
        to === "/" ? currentPath === "/" : currentPath.startsWith(to)
      );
      return item
        ? {
            title: item.title,
            subtitle: "Navegue e opere o módulo com visual mais limpo e consistente.",
          }
        : null;
    },
    syncMenuGroups() {
      const routeName = this.$route.name;
      this.submenuOperations = [
        "withdrawal",
        "trasactions",
        "products",
        "productsSignatureView",
      ].includes(routeName);
      this.submenuNetwork = [
        "franchisees",
        "franchiseeForm",
        "franchiseeDetail",
        "franchises",
        "franchiseForm",
        "franchiseDetail",
        "associatesView",
      ].includes(routeName);
      this.submenuContent = ["categoriesView", "tutorials"].includes(routeName);
      if (this.isMobile) {
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },
    handleDrawerToggle() {
      this.drawer = !this.drawer;
    },
    handleLogout() {
      this.openExit = false;
      localStorage.removeItem("tokens");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
.app-drawer {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), transparent),
    linear-gradient(180deg, var(--color-sidebar) 0%, #111827 100%) !important;
  border-right: 1px solid rgba(148, 163, 184, 0.18);
}

.app-drawer__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 16px 14px;
}

.app-drawer__brand-copy {
  flex: 1;
  min-width: 0;
}

.app-drawer__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
}

.app-drawer__title {
  display: block;
  color: var(--color-sidebar-text-strong);
  font-size: 1rem;
  line-height: 1.2;
}

.app-drawer__subtitle {
  margin: 4px 0 0;
  color: var(--color-sidebar-text);
  font-size: 0.8rem;
}

.app-drawer__divider {
  border-color: rgba(148, 163, 184, 0.15) !important;
}

.app-drawer__section-label {
  padding: 14px 16px 6px;
  color: rgba(255, 255, 255, 0.46);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.app-drawer__nav {
  padding: 0 10px;
}

.app-drawer__item {
  min-height: 40px;
  margin-bottom: 2px;
  border-radius: 12px;
  color: var(--color-sidebar-text);
}

.app-drawer__item--nested {
  padding-left: 12px !important;
}

.app-drawer__item--active,
.app-drawer__item.router-link-exact-active,
.app-drawer__item.router-link-active {
  color: var(--color-sidebar-text-strong) !important;
  background: rgba(255, 255, 255, 0.08);
}

::v-deep .app-drawer__group > .v-list-group__header {
  min-height: 40px;
  margin-bottom: 2px;
  border-radius: 12px;
  color: var(--color-sidebar-text);
}

::v-deep .app-drawer__group > .v-list-group__header--active {
  color: var(--color-sidebar-text-strong) !important;
  background: rgba(255, 255, 255, 0.08);
}

::v-deep .app-drawer__group .v-list-group__items .v-list-item {
  color: var(--color-sidebar-text);
}

.app-toolbar {
  border-bottom: 1px solid var(--color-border);
}

.app-toolbar__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.app-toolbar__eyebrow {
  color: var(--color-primary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.app-toolbar__header {
  display: flex;
  align-items: center;
}

.app-toolbar__title {
  margin-top: 4px;
  color: var(--color-text);
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.app-toolbar__subtitle {
  margin: 4px 0 0;
  color: var(--color-text-muted);
  font-size: 0.94rem;
}

.app-toolbar__actions {
  display: flex;
  align-items: center;
}

.logout-dialog {
  overflow: hidden;
}

.logout-dialog__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 16px;
  border-radius: 16px;
  background: rgba(225, 29, 72, 0.08);
}

.logout-dialog__title {
  margin: 0 0 8px;
  color: var(--color-text);
  font-size: 1.35rem;
  font-weight: 700;
}

.logout-dialog__text {
  margin: 0;
  color: var(--color-text-muted);
  line-height: 1.6;
}

@media (max-width: 960px) {
  .app-toolbar__subtitle {
    display: none;
  }

  .app-toolbar__actions .v-btn--outlined {
    display: none;
  }
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>

<style lang="scss">
.header:empty {
  display: none !important;
  margin: 0 !important;
}
</style>
